import { ApiFragment, MH2MediaType, MH2Types } from '@stylehaven/components';
import trimEnd from 'lodash-es/trimEnd';

/* sheijens 2021-12-23

'referenceUrl' and 'permalink' are similar but not really the same.
At least now due to functional requirements.

The 'referenceUrl' parameter is an app-specific canonical url, that
brings the end user back to the correct object within the correct app.

So for MH2 this would likely be /mh/id/:id and MediaHaven 2.0 would resolve this
internally to the correct view. A similar setup could be done for MHPortal.

The 'permalink' on the other hand is used for public/social sharing
and _must_ be publicly available. This can point to the MHPortal,
but it might be better to have this point to a generic url which
could then resolve to the correct application.

e.g. /permalink/id/:id --> redirect to /mh or /portal depending on business logic.

*/

export function GetRecordReferenceUrl(record: ApiFragment, baseUrl?: string): string {
    const recordId: string = record.getFragmentId();
    return GetRecordIdReferenceUrl(recordId, record.getType(), baseUrl);
}

export function GetRecordIdReferenceUrl(recordId: string, type?: MH2MediaType, baseUrl?: string): string {
    const referenceUrl: string = type === MH2Types.Mh2Collection ? `collections/${recordId}` : `records/${recordId}`;

    return `${trimEnd(baseUrl, '/')}/${referenceUrl}`;
}

export function GetPermalink(record: ApiFragment, base?: string): string {
    const recordId: string = record.getFragmentId();

    return `${trimEnd(base, '/')}/${recordId}`;
}
